import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import VehicleLeftPanel from './VehicleLeftPanel';
import PricingBlock from './PricingBlock';
import PaymentHistoryBlock from './PaymentHistoryBlock';
import VehicleTitleBlock from './VehicleTitleBlock';
import DocumentsBlock from './DocumentsBlock';

const getTitleStatus = (vehicle: any): { label: string; bg: string } => {
  const tr = vehicle.transferRecord;
  if (tr?.status === 'title_issues') return { label: 'Title Issues', bg: '#AF2930' };
  if (tr?.date_title_received || tr?.x_title_inn === 'X') return { label: 'Title Received', bg: '#459B4A' };
  return { label: 'Waiting on Title', bg: '#CA8D57' };
};

const TitleStatusLabel = styled.div<{ bg: string }>`
  width: 100%;
  margin-top: auto;
  padding: 14px;
  background: ${({ bg }) => bg};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  height: 44px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface TransactionRecordCardProps {
  vehicle: any;
}

const Card = styled.div`
  display: flex;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  gap: 24px;
`;

const MiddleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  gap: 0;
`;

const BlockSeparator = styled.div`
  height: 24px;
`;

const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 320px;
  max-height: 600px;
  background: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
`;

const TransactionRecordCard = ({ vehicle }: TransactionRecordCardProps) => {
  const history = useHistory();
  const titleStatus = getTitleStatus(vehicle);

  return (
    <Card>
      <VehicleLeftPanel
        vehicle={vehicle}
        onImageClick={() => history.push(`/vehicles/${vehicle.id}/view`)}
        showAwarded={vehicle.status === 'awarded'}
      />
      <MiddleContainer>
        <DocumentsBlock vehicle={vehicle} />
        <PricingBlock vehicle={vehicle} />
        <BlockSeparator />
        <PaymentHistoryBlock vehicle={vehicle} />
        <BlockSeparator />
        <TitleStatusLabel bg={titleStatus.bg}>{titleStatus.label}</TitleStatusLabel>
      </MiddleContainer>
      <RightPanel>
        <VehicleTitleBlock vehicle={vehicle} />
      </RightPanel>
    </Card>
  );
};

export default TransactionRecordCard;
